import {
  ImportBatchFailedCommitteeRow,
  ImportBatchFailedCompanyRow,
  ImportBatchFailedIndividualRow,
  ImportBatchParsedFailedRows,
  PlatformImportBatchFailedResults
} from '@betterboards/shared/types/Import'

export function parseFailedEntry (
  entry: string | Record<string, unknown> | null | undefined
): Record<string, unknown> | null {
  if (entry === null || entry === undefined) {
    return null
  }
  if (typeof entry === 'string') {
    try {
      return JSON.parse(entry) as Record<string, unknown>
    } catch {
      return null
    }
  }
  if (typeof entry === 'object') {
    return entry
  }
  return null
}

export function parseImportBatchFailed (failed: PlatformImportBatchFailedResults): ImportBatchParsedFailedRows {
  const toCompany = (entry: string | null | undefined): ImportBatchFailedCompanyRow | null => {
    const row = parseFailedEntry(entry)
    if (!row) {
      return null
    }
    return {
      name: typeof row.name === 'string' ? row.name : undefined
    }
  }

  const toIndividual = (entry: string | null | undefined): ImportBatchFailedIndividualRow | null => {
    const row = parseFailedEntry(entry)
    if (!row) {
      return null
    }
    return {
      preferredName: typeof row.preferredName === 'string' ? row.preferredName : undefined,
      role: typeof row.role === 'string' ? row.role : undefined,
      email: typeof row.email === 'string' ? row.email : undefined
    }
  }

  const toCommittee = (entry: string | null | undefined): ImportBatchFailedCommitteeRow | null => {
    const row = parseFailedEntry(entry)
    if (!row) {
      return null
    }
    const result: ImportBatchFailedCommitteeRow = {
      name: typeof row.name === 'string' ? row.name : undefined
    }
    if (typeof row.members === 'string') {
      result.members = row.members
    } else if (Array.isArray(row.members)) {
      result.members = row.members.filter((m): m is string => typeof m === 'string')
    }
    return result
  }

  return {
    company: (failed.company ?? []).map(toCompany).filter((row): row is ImportBatchFailedCompanyRow => row !== null),
    individuals: (failed.individuals ?? []).map(toIndividual).filter((row): row is ImportBatchFailedIndividualRow => row !== null),
    committees: (failed.committees ?? []).map(toCommittee).filter((row): row is ImportBatchFailedCommitteeRow => row !== null)
  }
}
